export enum RowGutter {
  Default = 8,
}
